/* Assay — theme behaviour
   No framework, no build step. Everything is progressive: the theme works
   with JavaScript switched off, this file only makes it quieter and faster. */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var routes = (window.Assay && window.Assay.routes) || {};
  var strings = (window.Assay && window.Assay.strings) || {};

  /* ---------------------------------------------------------------------
     Helpers
     --------------------------------------------------------------------- */

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function money(cents) {
    if (window.Assay && typeof window.Assay.formatMoney === 'function') {
      return window.Assay.formatMoney(cents);
    }
    return (cents / 100).toFixed(2);
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function toast(message) {
    var el = $('#toast');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-on');
    clearTimeout(el._timer);
    el._timer = setTimeout(function () { el.classList.remove('is-on'); }, 2600);
  }

  /* ---------------------------------------------------------------------
     Drawers (menu, cart, search)
     --------------------------------------------------------------------- */

  var lastFocused = null;
  var lockedAt = 0;

  function lockScroll() {
    lockedAt = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = '-' + lockedAt + 'px';
    document.body.classList.add('is-locked');
  }

  function unlockScroll() {
    document.body.classList.remove('is-locked');
    document.body.style.top = '';
    window.scrollTo(0, lockedAt);
  }

  function openDrawer(id) {
    var drawer = document.getElementById(id);
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    lockScroll();
    var focusable = drawer.querySelector('input, button, a[href]');
    if (focusable) setTimeout(function () { focusable.focus(); }, 120);
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) unlockScroll();
    if (lastFocused) lastFocused.focus();
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      event.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'));
      return;
    }
    if (event.target.closest('[data-drawer-close]') || event.target.classList.contains('drawer__scrim')) {
      closeDrawer(event.target.closest('.drawer'));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      var open = $('.drawer.is-open');
      if (open) closeDrawer(open);
      $$('.facet.is-open').forEach(function (f) { f.classList.remove('is-open'); });
    }
    // Trap focus inside an open drawer
    if (event.key === 'Tab') {
      var drawer = $('.drawer.is-open');
      if (!drawer) return;
      var items = $$('a[href], button:not([disabled]), input:not([disabled]), select, textarea', drawer)
        .filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first.focus();
      }
    }
  });

  /* ---------------------------------------------------------------------
     Cart — add, change, re-render the drawer via the Section Rendering API
     --------------------------------------------------------------------- */

  function refreshCart() {
    var sectionId = document.body.getAttribute('data-cart-drawer-section') || 'cart-drawer';
    return fetch(routes.cart_url + '?sections=' + sectionId, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-cart-contents]');
        var current = $('[data-cart-contents]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;

        var freshCount = parsed.querySelector('[data-cart-count]');
        if (freshCount) {
          $$('[data-cart-count]').forEach(function (node) {
            node.textContent = freshCount.textContent;
          });
        }
      });
  }

  function addToCart(form, button) {
    var body = new FormData(form);
    body.append('sections', document.body.getAttribute('data-cart-drawer-section') || 'cart-drawer');
    var label = button ? button.innerHTML : '';
    if (button) {
      button.setAttribute('aria-disabled', 'true');
      button.innerHTML = '<span class="spinner" aria-hidden="true"></span>';
    }

    fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast(res.json.description || res.json.message || strings.cartError || 'Could not add that item.');
          return;
        }
        return refreshCart().then(function () {
          openDrawer('cart-drawer');
        });
      })
      .catch(function () { toast(strings.cartError || 'Could not add that item.'); })
      .finally(function () {
        if (button) {
          button.removeAttribute('aria-disabled');
          button.innerHTML = label;
        }
      });
  }

  function changeLine(key, quantity) {
    var sectionId = document.body.getAttribute('data-cart-drawer-section') || 'cart-drawer';
    return fetch(routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: sectionId })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (document.body.getAttribute('data-template') === 'cart') {
          window.location.reload();
          return;
        }
        return refreshCart();
      });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('[data-product-form]')) return;
    if (document.body.getAttribute('data-cart-type') !== 'drawer') return;
    event.preventDefault();
    addToCart(form, form.querySelector('[data-add-button]'));
  });

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-line-remove]');
    if (remove) {
      event.preventDefault();
      changeLine(remove.getAttribute('data-line-key'), 0);
      return;
    }
    var step = event.target.closest('[data-qty-step]');
    if (step) {
      event.preventDefault();
      var input = step.parentElement.querySelector('input');
      var next = parseInt(input.value, 10) + parseInt(step.getAttribute('data-qty-step'), 10);
      var min = parseInt(input.getAttribute('min') || '1', 10);
      input.value = Math.max(min, next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches('[data-line-qty]')) return;
    changeLine(input.getAttribute('data-line-key'), parseInt(input.value, 10));
  });


  /* ---------------------------------------------------------------------
     Enquiry — catalogue pieces are requested, not added to a bag
     --------------------------------------------------------------------- */

  function currentVariantText() {
    var picker = $('[data-variant-picker]');
    if (!picker) return '';
    return $$('input[type="radio"]:checked', picker)
      .map(function (input) {
        var group = input.closest('.variant-group');
        var name = group ? (group.querySelector('.t-mark') || {}).firstChild : null;
        var label = name && name.textContent ? name.textContent.trim() : '';
        return label ? label + ': ' + input.value : input.value;
      })
      .join(' / ');
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-enquire]');
    if (!trigger) return;

    var title = trigger.getAttribute('data-product-title') || '';
    var url = trigger.getAttribute('data-product-url') || window.location.href;
    var image = trigger.getAttribute('data-product-image') || '';
    var sku = trigger.getAttribute('data-product-sku') || '';
    var variant = currentVariantText();

    var summary = $('[data-enquiry-summary]');
    if (summary) {
      summary.hidden = false;
      var titleNode = $('[data-enquiry-title]', summary);
      var variantNode = $('[data-enquiry-variant]', summary);
      var imageNode = $('[data-enquiry-image]', summary);
      if (titleNode) titleNode.textContent = title;
      if (variantNode) variantNode.textContent = [variant, sku].filter(Boolean).join(' · ');
      if (imageNode) imageNode.innerHTML = image ? '<img src="' + image + '" alt="">' : '';
    }

    var descriptor = title + (variant ? ' — ' + variant : '') + (sku ? ' (' + sku + ')' : '');

    var productField = $('[data-enquiry-field-product]');
    if (productField) productField.value = descriptor;

    var urlField = $('[data-enquiry-field-url]');
    if (urlField) urlField.value = url;

    var wa = $('[data-whatsapp]');
    if (wa && window.Assay.whatsapp) {
      var number = String(window.Assay.whatsapp).replace(/[^0-9]/g, '');
      var text = (strings.enquiryPrefix || 'I would like to enquire about') + ' ' + descriptor + ' — ' + url;
      wa.setAttribute('href', 'https://wa.me/' + number + '?text=' + encodeURIComponent(text));
    }
  });

  // Shopify redirects after a contact form post, so reopen the drawer to show
  // the confirmation rather than leaving the visitor on a silent page.
  if (window.location.search.indexOf('contact_posted=true') !== -1 && $('#enquiry-drawer .enquiry-success')) {
    openDrawer('enquiry-drawer');
  }

  /* ---------------------------------------------------------------------
     Component mounting

     Everything below is scoped to a root element rather than the document, so
     a section added or edited in the theme editor can be mounted on its own.
     Without this, dropping a hero slider onto a page in the editor would give
     the merchant dead arrows until they refreshed.
     --------------------------------------------------------------------- */

  var revealObserver = (!reduceMotion && 'IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 })
    : null;

  function mount(root) {
    root = root || document;

  /* ---------------------------------------------------------------------
     Variant picker
     --------------------------------------------------------------------- */

  $$('[data-variant-picker]', root).forEach(function (picker) {
    if (picker.dataset.mounted) return;
    picker.dataset.mounted = '1';
    var dataEl = $('[data-variant-json]', picker);
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var form = document.getElementById(picker.getAttribute('data-form-id'));
    var idInput = form ? form.querySelector('[data-variant-id]') : null;

    function selectedOptions() {
      return $$('input[type="radio"]:checked, select[data-option-index]', picker).map(function (el) {
        return el.value;
      });
    }

    function matchVariant(options) {
      return variants.find(function (variant) {
        return variant.options.every(function (value, i) { return value === options[i]; });
      });
    }

    function markUnavailable(options) {
      $$('input[type="radio"]', picker).forEach(function (input) {
        var index = parseInt(input.getAttribute('data-option-index'), 10);
        var trial = options.slice();
        trial[index] = input.value;
        var candidate = variants.filter(function (variant) {
          return variant.options[index] === input.value &&
            trial.every(function (value, i) { return i === index || variant.options[i] === value; });
        });
        var any = candidate.some(function (variant) { return variant.available; });
        input.disabled = candidate.length > 0 ? !any : true;
      });
    }

    function update() {
      var options = selectedOptions();
      var variant = matchVariant(options);
      markUnavailable(options);

      var scope = picker.closest('.product__info') || root;
      var priceNode = $('[data-price-target]', scope);
      var button = form ? form.querySelector('[data-add-button]') : null;
      var badge = $('[data-availability]', scope);

      if (!variant) {
        if (button) {
          button.setAttribute('aria-disabled', 'true');
          button.textContent = strings.unavailable || 'Unavailable';
        }
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (priceNode) {
        var html = '<span class="price">' + money(variant.price) + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<span class="price--was">' + money(variant.compare_at_price) + '</span>';
        }
        priceNode.innerHTML = html;
      }

      if (button) {
        if (variant.available) {
          button.removeAttribute('aria-disabled');
          button.textContent = strings.addToCart || 'Add to bag';
        } else {
          button.setAttribute('aria-disabled', 'true');
          button.textContent = strings.soldOut || 'Sold out';
        }
      }

      if (badge) badge.textContent = variant.available ? (strings.inStock || 'Ready to ship') : (strings.soldOut || 'Sold out');

      var barPrice = $('[data-buy-bar-price]');
      if (barPrice) barPrice.textContent = money(variant.price);

      var barAdd = $('[data-buy-bar-add]');
      if (barAdd) barAdd.textContent = variant.available ? (strings.addToCart || 'Add to bag') : (strings.soldOut || 'Sold out');

      $$('[data-option-label]', root).forEach(function (label) {
    if (label.dataset.mounted) return;
    label.dataset.mounted = '1';
        var index = parseInt(label.getAttribute('data-option-label'), 10);
        label.textContent = variant.options[index];
      });

      if (variant.featured_media_id) {
        var thumb = $('[data-media-id="' + variant.featured_media_id + '"]');
        if (thumb) thumb.click();
      }

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    picker.addEventListener('change', update);
    update();
  });


  /* ---------------------------------------------------------------------
     Sticky buy bar (phones)
     --------------------------------------------------------------------- */

  (function () {
    var bar = $('[data-buy-bar]', root);
    var row = $('[data-buy-row]', root);
    if (!bar || !row || bar.dataset.mounted) return;
    bar.dataset.mounted = '1';

    bar.hidden = false;

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        // Show the bar only once the real buy row is above the fold line.
        var entry = entries[0];
        var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', passed);
      }, { threshold: 0 }).observe(row);
    }

    var mirror = $('[data-buy-bar-add]', bar);
    if (mirror) {
      mirror.addEventListener('click', function () {
        var primary = row.querySelector('[data-add-button]');
        if (primary) primary.click();
      });
    }
  })();

  /* ---------------------------------------------------------------------
     Gallery + the loupe
     --------------------------------------------------------------------- */

  $$('[data-gallery]', root).forEach(function (gallery) {
    if (gallery.dataset.mounted) return;
    gallery.dataset.mounted = '1';
    var stage = $('[data-stage]', gallery);
    var stageImg = stage ? stage.querySelector('img') : null;
    if (!stage || !stageImg) return;

    $$('[data-media-id]', gallery).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        var srcset = thumb.getAttribute('data-srcset');
        stageImg.setAttribute('src', full);
        if (srcset) stageImg.setAttribute('srcset', srcset);
        stageImg.setAttribute('alt', thumb.getAttribute('data-alt') || '');
        stage.setAttribute('data-zoom-src', thumb.getAttribute('data-zoom') || full);
        $$('[data-media-id]', gallery).forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });

    // The loupe: a 2.5x glass that tracks the cursor across the stone.
    if (reduceMotion || !window.matchMedia('(hover: hover)').matches) return;

    var loupe = document.createElement('div');
    loupe.className = 'loupe';
    loupe.setAttribute('aria-hidden', 'true');
    stage.appendChild(loupe);

    var zoom = 2.5;
    var rect = null;

    function measure() { rect = stage.getBoundingClientRect(); }

    stage.addEventListener('mouseenter', function () {
      measure();
      var src = stage.getAttribute('data-zoom-src') || stageImg.currentSrc || stageImg.src;
      loupe.style.backgroundImage = 'url("' + src + '")';
      loupe.style.backgroundSize = (rect.width * zoom) + 'px ' + (rect.height * zoom) + 'px';
      loupe.classList.add('is-on');
    });

    stage.addEventListener('mouseleave', function () { loupe.classList.remove('is-on'); });

    stage.addEventListener('mousemove', function (event) {
      if (!rect) measure();
      var x = event.clientX - rect.left;
      var y = event.clientY - rect.top;
      loupe.style.left = x + 'px';
      loupe.style.top = y + 'px';
      loupe.style.backgroundPosition = '-' + (x * zoom - loupe.offsetWidth / 2) + 'px -' + (y * zoom - loupe.offsetHeight / 2) + 'px';
    });

    window.addEventListener('resize', debounce(measure, 150));
  });


  /* ---------------------------------------------------------------------
     Hero slider
     --------------------------------------------------------------------- */

  $$('[data-slider]', root).forEach(function (slider) {
    if (slider.dataset.mounted) return;
    slider.dataset.mounted = '1';
    var slides = $$('[data-slide]', slider);
    if (slides.length < 2) return;

    var dots = $$('[data-slider-dot]', slider);
    var counter = $('[data-slider-current]', slider);
    var delay = parseInt(slider.getAttribute('data-autoplay'), 10) || 0;
    var index = 0;
    var timer = null;

    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      if (counter) counter.textContent = index + 1;
    }

    function start() {
      if (!delay || reduceMotion) return;
      stop();
      timer = setInterval(function () { show(index + 1); }, delay);
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    var prev = $('[data-slider-prev]', slider);
    var next = $('[data-slider-next]', slider);
    if (prev) prev.addEventListener('click', function () { show(index - 1); start(); });
    if (next) next.addEventListener('click', function () { show(index + 1); start(); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.getAttribute('data-slider-dot'), 10));
        start();
      });
    });

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);

    slider.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { show(index - 1); start(); }
      if (event.key === 'ArrowRight') { show(index + 1); start(); }
    });

    // Swipe
    var startX = null;
    slider.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; stop(); }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var delta = e.changedTouches[0].clientX - startX;
      if (Math.abs(delta) > 45) show(delta < 0 ? index + 1 : index - 1);
      startX = null;
      start();
    });

    // Pause when the slider is off screen — no point animating what nobody sees
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries[0].isIntersecting ? start() : stop();
      }, { threshold: 0.2 }).observe(slider);
    } else {
      start();
    }

    show(0);
  });

  /* ---------------------------------------------------------------------
     Horizontal rails
     --------------------------------------------------------------------- */

  $$('[data-rail]', root).forEach(function (rail) {
    if (rail.dataset.mounted) return;
    rail.dataset.mounted = '1';
    var section = rail.closest('section') || document;
    var nav = $('[data-rail-nav]', section);
    if (!nav) return;

    var prev = $('[data-rail-prev]', nav);
    var next = $('[data-rail-next]', nav);

    function step() {
      var first = rail.firstElementChild;
      return first ? first.getBoundingClientRect().width + 24 : rail.clientWidth * 0.8;
    }

    function sync() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });

    rail.addEventListener('scroll', debounce(sync, 80));
    window.addEventListener('resize', debounce(sync, 150));
    sync();
  });

  /* ---------------------------------------------------------------------
     Lookbook hotspots
     --------------------------------------------------------------------- */

  $$('[data-lookbook]', root).forEach(function (stage) {
    if (stage.dataset.mounted) return;
    stage.dataset.mounted = '1';
    var spots = $$('[data-hotspot]', stage);

    function closeAll(except) {
      spots.forEach(function (spot) {
        if (spot === except) return;
        spot.setAttribute('aria-expanded', 'false');
        var card = document.getElementById(spot.getAttribute('data-hotspot'));
        if (card) card.classList.remove('is-open');
      });
    }

    spots.forEach(function (spot) {
      var card = document.getElementById(spot.getAttribute('data-hotspot'));
      if (!card) return;

      spot.addEventListener('click', function (event) {
        event.stopPropagation();
        var open = spot.getAttribute('aria-expanded') === 'true';
        closeAll(spot);
        spot.setAttribute('aria-expanded', open ? 'false' : 'true');
        card.classList.toggle('is-open', !open);

        // Below 48em the card docks to the bottom of the photograph, so the
        // edge-flipping offsets only apply from tablet up.
        if (window.matchMedia('(min-width: 48em)').matches) {
          var x = parseFloat(spot.style.left);
          var y = parseFloat(spot.style.top);
          card.style.marginLeft = x > 60 ? '-13.5rem' : '1.25rem';
          card.style.marginTop = y > 55 ? '-13rem' : '1.25rem';
        }
      });
    });

    document.addEventListener('click', function () { closeAll(null); });
    stage.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll(null);
    });
  });

  /* ---------------------------------------------------------------------
     Utility bar message rotation
     --------------------------------------------------------------------- */

  $$('[data-rotator]', root).forEach(function (rotator) {
    if (rotator.dataset.mounted) return;
    rotator.dataset.mounted = '1';
    var messages = $$('[data-rotator-item]', rotator);
    if (messages.length < 2 || reduceMotion) {
      if (messages[0]) messages[0].classList.add('is-on');
      return;
    }
    var i = 0;
    messages[0].classList.add('is-on');
    setInterval(function () {
      messages[i].classList.remove('is-on');
      i = (i + 1) % messages.length;
      messages[i].classList.add('is-on');
    }, parseInt(rotator.getAttribute('data-rotator'), 10) || 5000);
  });

  /* ---------------------------------------------------------------------
     Predictive search
     --------------------------------------------------------------------- */

  $$('[data-predictive]', root).forEach(function (wrapper) {
    if (wrapper.dataset.mounted) return;
    wrapper.dataset.mounted = '1';
    var input = $('input[type="search"]', wrapper);
    var results = $('[data-predictive-results]', wrapper);
    if (!input || !results) return;

    var run = debounce(function () {
      var term = input.value.trim();
      if (term.length < 2) { results.innerHTML = ''; return; }

      fetch(routes.predictive_search_url + '?q=' + encodeURIComponent(term) +
        '&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.querySelector('[data-predictive-results]');
          results.innerHTML = fresh ? fresh.innerHTML : '';
        })
        .catch(function () { results.innerHTML = ''; });
    }, 260);

    input.addEventListener('input', run);
  });


    $$('[data-facet-form]', root).forEach(function (form) {
      if (form.dataset.mounted) return;
      form.dataset.mounted = '1';
      form.addEventListener('change', function () { form.submit(); });
    });

    $$('.reveal', root).forEach(function (el) {
      if (revealObserver) { revealObserver.observe(el); } else { el.classList.add('is-in'); }
    });
  }
  /* ---------------------------------------------------------------------
     Facets
     --------------------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-facet-toggle]');
    if (toggle) {
      var facet = toggle.closest('.facet');
      var wasOpen = facet.classList.contains('is-open');
      $$('.facet.is-open').forEach(function (f) { f.classList.remove('is-open'); });
      if (!wasOpen) facet.classList.add('is-open');
      return;
    }
    if (!event.target.closest('.facet')) {
      $$('.facet.is-open').forEach(function (f) { f.classList.remove('is-open'); });
    }
  });





  /* ---------------------------------------------------------------------
     Theme editor hooks
     --------------------------------------------------------------------- */

  mount(document);

  document.addEventListener('shopify:section:load', function (event) {
    mount(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    var drawerId = event.target.getAttribute('data-editor-drawer');
    if (drawerId) openDrawer(drawerId);
  });
})();
